import { UAParser } from "ua-parser-js";
import { isStandalonePWA } from "ua-parser-js/helpers";

export function currentPageHelper(url: string) {
    return {
        url,
    };
}

export function referrerHelper(url: string) {
    return {
        referrer: url,
    };
}

export function pageViewHelper(title: string, location: Location) {
    return {
        current_page_title: title,
        current_domain: location.hostname,
        current_url_path: location.pathname,
        current_url_protocol: location.protocol,
        current_url_search: location.search,
    };
}

export function userAgentHelper(ua: string) {
    const parsed = UAParser(ua);

    return {
        os: parsed.os.name,
        osVersion: parsed.os.version,
        browser: parsed.browser.name,
        browserVersion: parsed.browser.version,
        device:
            parsed.device.vendor &&
            parsed.device.model &&
            `${parsed.device.vendor} ${parsed.device.model}`,
        deviceModel: parsed.device.model,
        deviceManufacturer: parsed.device.vendor,
        // custom UA props
        deviceProperties: {
            ua: parsed.ua,
            isStandalonePWA: isStandalonePWA(),
        },
    };
}
